import { connectRoutes } from 'redux-first-router'
import routePaths from './routePaths'

const {
    reducer,
    middleware,
    enhancer,
    initialDispatch,
} = connectRoutes(routePaths, { initialDispatch: false })

export const routerMiddleware = middleware
export const routerEnhancer = enhancer
export const initDispatch = initialDispatch
export const locationReducer = reducer
